import "../app/Routes/Login/login.scss";
import { type FC } from "react";
import ShopfrontLogo from "../app/Common/Misc/ShopfrontLogo";
import PopupContainer from "../app/Common/Popups/PopupContainer";
import LoginBox from "./Common/LoginBox";

const GlobalLogin: FC = () => {
    return (
        <>
            <PopupContainer />
            <div id="login-screen" className="type">
                <div id="login-screen-flex-child">
                    <ShopfrontLogo />
                    <LoginBox />
                </div>
            </div>
        </>
    );
};

export default GlobalLogin;
